import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles({
  root: {
    width: "100%",
    padding: "20px",
    display: "flex",
    flexDirection: "column",
  },
});
